<p-dialog
  [(visible)]="open"
  [closeOnEscape]="true"
  modal="modal"
  showEffect="fade"
  [keepInViewport]="false"
  [draggable]="false"
  [style]="{ position: 'absolute', width: '100%' }" 
  (onHide)="onClose()"
>
  <div class="grid justify-content-center">
    <div class="col-12 align-items-center justify-content-center">
      <div class="card">
        <h5 class="m-0">Seleccionar {{ settings.title }}</h5>
        <br />
        <p-progressBar
          *ngIf="listingData"
          mode="indeterminate"
          [style]="{ height: '6px' }"
        ></p-progressBar>
        <p-table
          #dt
          [value]="data"
          [columns]="selectedColumns"
          [rows]="10"
          [paginator]="true"
          [rowsPerPageOptions]="[10, 20, 30]"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
          selectionMode="single"
          [rowHover]="true"
          dataKey="id"
          [responsive]="true"
          [resizableColumns]="true"
          columnResizeMode="expand"
          [reorderableColumns]="true"
          (onRowSelect)="onRowSelect($event)"
          styleClass="p-datatable-gridlines p-datatable-striped p-datatable-sm"
        >
          <ng-template pTemplate="caption">
            <div
              class="flex flex-column md:flex-row md:justify-content-between md:align-items-center"
            >
              <div class="flex align-items-center justify-content-center">
                <p-multiSelect
                  [options]="settings.columns"
                  [(ngModel)]="selectedColumns"
                  optionLabel="header"
                  selectedItemsLabel="{0} columnas seleccionadas"
                  [style]="{ width: '100%' }"
                  placeholder="Filtrar Columna"
                  class="mt-0 mb-2 md:mt-0"
                ></p-multiSelect>
                <span class="block ml-3 mb-2 p-input-icon-left w-24rem">
                  <i class="pi pi-search"></i>
                  <input
                    style="width: 100%"
                    pInputText
                    type="text"
                    (input)="dt.filterGlobal($event.target.value, 'contains')"
                    placeholder="Buscar..."
                  />
                </span>
              </div>
            </div>
          </ng-template>

          <ng-template pTemplate="header">
            <tr>
              <th
                *ngFor="let col of selectedColumns"
                pSortableColumn="{{ col.field }}"
              >
                {{ col.header }}
                <p-sortIcon field="{{ col.field }}"></p-sortIcon>
              </th>
            </tr>
            <tr>
              <th *ngFor="let col of selectedColumns">
                <input
                  id="filterColumn"
                  pInputText
                  style="width: 75%; max-width: 75%"
                  type="text"
                  (input)="
                    dt.filter($event.target.value, col.field, 'contains')
                  "
                />
              </th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-rowData>
            <tr [pSelectableRow]="rowData">
              <td *ngFor="let col of selectedColumns; let i=index">
                <span class="p-column-title">{{ col.header }}</span>

                <p
                  *ngIf="
                  selectedColumns[i].tag !== 'tagStatus'
                "
                >
                  {{ rowData[col.field] }}
                </p>

                <p-tag *ngIf="selectedColumns[i].tag === 'tagStatus'"
                       [style]="{'background': rowData['tagStatusColor']}"
                       [severity]="rowData['statusTag']">
                  {{rowData[col.field]}}
                </p-tag>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</p-dialog>
